<template>
  <div :class="['betslip-page pmbetslip-wrap', {'loggedin' : isLoggedIn}, {'bet_placed_sucessfuly' : placeBetStatus == 'P'}]">
    <div v-if="brandTemplate !=='generic_2' && isLoggedIn && placeBetStatus !== 'P'" class="preheader">
      <div class="betslip_balance"><span class="span_balance">{{ $t('BetSlipPage.tab.balance') }}</span><span class="value">{{balanceSum | currency}}</span></div>
      <v-btn flat @click="toggleBetslip()" class="close"><v-icon>close</v-icon></v-btn>
    </div>
    <div v-if="brandTemplate !== 'generic_2' && placeBetStatus !== 'P'" class="betslip-page-header" :class="{'user_logged_in' : isLoggedIn}">
      <span class="tab active disabled">
        <a class="a-link-"><span>{{ $t('Betslip.PM.Title') }}</span><badge>{{selectedRunnersCount}}</badge></a>
       </span>
    </div>
    <div v-if="brandTemplate === 'generic_2' && placeBetStatus !== 'P'" class="betslip-page-header" :class="{'user_logged_in' : isLoggedIn}">
      <span class="tab active disabled">
        <a class="a-link-">
          <badge>{{selectedRunnersCount}}</badge>
          <span>{{ $t('Betslip.PM.Title') }}
            <div class="betslip_balance">
              <span class="span_balance">{{ $t('BetSlipPage.tab.balance') }}</span>
              <span class="value">{{ balanceSum | currency }}</span>
            </div>
          </span>
        </a>
       </span>
       <span v-if="mobileBigAndBelow" @click="toggleBetslip()" class="betslip_down_icon"></span>
       <a v-if="mobileBigAndBelow" @click="toggleBetslip()" class="close">{{ $t('BetSlip.tab.label.close') }}</a>
    </div>
    <div class="betslip-page-header pmBetPlaced" v-if="placeBetStatus == 'P'">
      <span class="your_receipt" key="your_receipt">{{ $t('BetSlip.status.placed.YourReceipt') }}</span>
      <v-btn flat @click="dismissBetslip()" class="close"><v-icon>close</v-icon></v-btn>
    </div>
    <div class="mobile_betslip" :class="{'pmBetPlaced' : placeBetStatus == 'P'}">
      <betslip></betslip>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import Loader from '@/components/common/Loader'
import Screen from '@/components/mixins/Screen'
import PariMutuel from '@/components/mixins/PariMutuel'
import Betslip from '@/components/parimutuel/betting/betslip'
import Branding from '@/components/mixins/Branding'
import Badge from '@/components/common/Badge'

export default {
  name: 'betslipmobile',

  components: {
    Loader,
    Betslip,
    Badge
  },

  mixins: [
    Screen,
    PariMutuel,
    Branding
  ],

  data () {
    return {
    }
  },

  computed: {
    pmShowBetSlip () { return store.getters['pmBetslipState/getShowBetSlip'] },
    placeBetStatus () { return store.getters['pmBetslipState/getPlaceBetStatus'] },
    selectedRunnersCount () { return store.getters['pmBetslipState/getSelectedRunnersCount'] },
    isLoggedIn () { return store.getters['isLoggedIn'] },
    customerContext () { return store.getters['getCustomerContext'] },
    balanceSum () { return (this.customerContext && this.customerContext.Balances && this.customerContext.Balances.find(b => b.Key === 'CREDIT').Trading) || undefined }
  },

  filters: {
  },

  methods: {
    dismissBetslip () {
      store.dispatch('pmBetslipState/resetBetslip')
      store.dispatch('pmBetslipState/resetBetslipStatus')
      store.dispatch('pmBetslipState/toggleBetslip')
    },
    toggleBetslip () {
      store.dispatch('pmBetslipState/toggleBetslip')
    },
    toggleRaceInfo () {
      let raceInfoElms = document.getElementsByClassName('race-info')
      if (raceInfoElms && raceInfoElms.length > 0 && raceInfoElms[0].classList.contains('race-info-collapsed')) {
        raceInfoElms[0].classList.remove('race-info-collapsed')
      } else {
        raceInfoElms[0].classList.add('race-info-collapsed')
      }
    }
  },

  mounted () {
    this.pmRaceClockStart()
  },
  destroyed () {
  }
}
</script>
<style lang="stylus" scoped>
  .your_receipt
    font-size: 16px
    text-transform: uppercase
    line-height: 62px
    padding-left: 15px
</style>



// WEBPACK FOOTER //
// src/components/parimutuel/betting/BetslipMobile.vue